import siteMessage from "@insite/client-framework/SiteMessage";
import activateInvite from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ActivateInvite";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PageErrorWrapper, PageErrorWrapperStyles } from "@insite/content-library/Components/PageErrorWrapper";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import useQueryString from "@store/Framework/Common/Hooks/useQueryString";
import { useWishListState } from "@store/Framework/Store/Data/MyLists/MyListsHooks";
import { useLocation } from "@store/Framework/Store/Data/Pages/PageHooks";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

export interface MyListsDetailsPageContainerStyles {
    pageErrorWrapper?: PageErrorWrapperStyles;
}

export const myListsDetailsPageContainerStyles: MyListsDetailsPageContainerStyles = {};

const mapDispatchToProps = {
    activateInvite,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

const styles = myListsDetailsPageContainerStyles;

const MyListsDetailsPageContainer: FC<Props> = ({ id: widgetId, activateInvite }) => {
    const history = useHistory();
    const location = useLocation();
    const { id, invite } = useQueryString();
    const wishlistDataView = useWishListState(id);
    const [inviteIsNotAvailable, setInviteIsNotAvailable] = useState(false);

    if (invite) {
        activateInvite({
            invite,
            onSuccess: wishList => {
                history.replace(`${location.pathname}?id=${wishList.id}`);
            },
            onError: () => {
                setInviteIsNotAvailable(true);
            },
            onComplete(wishListProps) {
                if (wishListProps.result?.wishList) {
                    this.onSuccess?.(wishListProps.result.wishList);
                } else if (wishListProps.result?.errorMessage !== undefined) {
                    // possible empty string error here
                    this.onError?.(wishListProps.result.errorMessage);
                }
            },
        });
    }

    return (
        <PageErrorWrapper
            value={wishlistDataView}
            extendedStyles={styles.pageErrorWrapper}
            notFoundMessage={siteMessage("Lists_List_NotFound")}
            customErrorMessage={inviteIsNotAvailable ? siteMessage("Lists_InviteIsNotAvailable") : null}
            loadFailedWrapperTestSelector="listNotAvailable"
        >
            <OrderLayout id={widgetId} />
        </PageErrorWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(MyListsDetailsPageContainer),
    definition: {
        displayName: "Page Container",
        group: "My Lists Details",
        allowedContexts: ["MyListsDetailsPage"],
    },
};
export default widgetModule;
